import { render } from "./scroll-to-top-button.vue?vue&type=template&id=0fecee15"
import script from "./scroll-to-top-button.vue?vue&type=script&lang=js"
export * from "./scroll-to-top-button.vue?vue&type=script&lang=js"

import "./scroll-to-top-button.vue?vue&type=style&index=0&id=0fecee15&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__